import { http } from "../client";
var mapSettings = function (object) { return ({
    mailHost: object.mail_host,
    mailPort: object.mail_port,
    mailEncryption: object.mail_encryption || "none",
    mailUsername: object.mail_username,
    mailPassword: object.mail_password,
    mailFromAddress: object.mail_from_address,
    mailFromName: object.mail_from_name,
    clientAccessMailSubject: object.client_access_mail_subject,
    clientAccessMailTemplate: object.client_access_mail_template,
    passwordResetMailSubject: object.password_reset_mail_subject,
    passwordResetMailTemplate: object.password_reset_mail_template,
}); };
var mapRequest = function (settings) { return ({
    mail_host: settings.mailHost,
    mail_port: settings.mailPort,
    mail_encryption: settings.mailEncryption,
    mail_username: settings.mailUsername,
    mail_password: settings.mailPassword,
    mail_from_address: settings.mailFromAddress,
    mail_from_name: settings.mailFromName,
    client_access_mail_subject: settings.clientAccessMailSubject,
    client_access_mail_template: settings.clientAccessMailTemplate,
    password_reset_mail_subject: settings.passwordResetMailSubject,
    password_reset_mail_template: settings.passwordResetMailTemplate,
}); };
var get = function () {
    return http.api
        .get("admin/mail-settings")
        .then(function (res) { return mapSettings(res.data.data); });
};
var update = function (settings) {
    return http.api
        .put("admin/mail-settings", mapRequest(settings))
        .then(function (res) { return mapSettings(res.data.data); });
};
export var mailSettingsApi = {
    get: get,
    update: update,
};
